import { VendorCommitments as VendorCommitmentsComponent } from '../../../components/Commitment/Categories/VendorCommitments';

export function VendorCommitments() {
  return <VendorCommitmentsComponent />;
}
